// NIST 800-63B 5.1.1.2 Memorized Secret Verifiers (https://pages.nist.gov/800-63-3/sp800-63b.html)
// In order to assist the claimant in successfully entering a memorized secret, 
// the verifier SHOULD offer an option to display the secret — rather than a series of dots or asterisks — until it is entered.
// This allows the claimant to verify their entry if they are in a location where their screen is unlikely to be observed.
//
((document) => {
    [].slice.call(document.querySelectorAll('input[type="password"]')).map(function (el: HTMLInputElement) {
        const icon = document.createElement('i');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'btn btn-outline-secondary border-input show-password'
        btn.style.borderLeftWidth = '0px';
        btn.tabIndex = -1;
        btn.appendChild(icon);
        btn.addEventListener('click', function () { render(el, el.type === 'password'); });

        el.parentElement!.appendChild(btn);
        el.parentElement?.classList.add('show-password-group')

        const render = function (el: HTMLInputElement, show: boolean) {
            el.type = show ? 'text' : 'password';
            icon.className = 'fas fa-fw fa-' + (show ? 'eye-slash' : 'eye');
            btn.title = (show ? 'Hide' : 'Show') + ' password'
        };

        render(el, false);
    });
})(document);